import { modalAccessibility } from "./modalAccessibility";
let header = document.getElementById("header");
let mainMenuToggle = document.getElementById("main-menu-toggle");
let mainMenuContainer = document.getElementById("main-menu");
let headerMenus = document.getElementsByClassName("header__menu");
let mainMenuButtons = document.getElementsByClassName("menu-main__link--btn");
let mainSubmenus = document.getElementsByClassName("menu-main__sub-list");
let featured = document.getElementById("menu-featured");
let searchFormTrigger = document.getElementById("search-form-toggle");
let leftMenuMobileContainer = document.getElementById("mobile-left-menu");
let menuMainlistMain = document.getElementsByClassName("menu-main__list--main");
let backMenuBtnBurger = document.getElementsByClassName(
  "back-menu__btn--level-1"
);
let backMenuBtnBurgerTwo = document.getElementsByClassName(
  "back-menu__btn--level-3"
);
let searchForm = document.getElementById("search-form");
let closeForm = document.getElementById("search-close");
let skipLink = document.getElementById("skip-link");
let tilesMenuFeatured = document.querySelectorAll(
  ".menu-container__featured .tile"
);

// Expand/collapse main menu container.
mainMenuToggle.addEventListener("click", function (e) {
  // Check menu toggle current state to decide if we expand or collapse main menu container.
  let isOpen = this.getAttribute("aria-expanded") === "true";

  if (isOpen) {
    // Close main menu.
    closeMainMenu();

    // Close all main menu submenus.
    closeSubmenus();

    // Remove class that stops page scrolling.
    document.body.classList.remove("body-freeze");

    // Remove header gradient class (used on mobile menu).
    header.classList.remove("header--aqua-gradient");

    // Remove class that hides search form toggle on mobile.
    searchFormTrigger.classList.remove("search-toggle--mobile-hidden");
  } else {
    searchForm.classList.remove("search-form--open");
    searchFormTrigger.setAttribute("aria-expanded", "false");
    searchFormTrigger.classList.remove("search-toggle--form-open");
    closeForm.setAttribute("aria-expanded", "false");
    mainMenuContainer.classList.add("menu-container--open");
    mainMenuToggle.setAttribute("aria-expanded", "true");
    mainMenuToggle.classList.add("menu-toggle--open");

    // Show other header menu (left/right).
    Array.from(headerMenus).forEach((el) => {
      el.classList.add("header__menu--hidden");
    });

    // Add class to stop page scrolling.
    document.body.classList.add("body-freeze");

    // Add header gradient class (used on mobile menu).
    header.classList.add("header--aqua-gradient");

    // Add class that hides search form toggle on mobile.
    searchFormTrigger.classList.add("search-toggle--mobile-hidden");

    if (this.closest(".menu-main__sub-list--open")) {
      this.closest(".menu-main__sub-list--open").classList.remove(
        "menu-main__sub-list--hidden"
      );
    }

    Array.from(mainSubmenus).forEach((el) => {
      el.classList.remove("menu-main__sub-list--open");
    });

    Array.from(mainMenuButtons).forEach((el) => {
      el.setAttribute("aria-expanded", "false");
    });
    menuMainlistMain[0].classList.remove("menu-main__list--main-open");
    modalAccessibility("#header");
  }
});

// Collapse main menu container when esc key is pressed.
document.addEventListener("keydown", function (e) {
  if (e.key === "Escape") {
    // Close main menu.
    closeMainMenu();

    // Close all main menu submenus.
    closeSubmenus();
  }
});

/* Close menu when skip link is clicked */
skipLink.addEventListener("click", function () {
  // Close main menu.
  closeMainMenu();

  // Close all main menu submenus.
  closeSubmenus();
});

// Submenus.
for (let i = 0; i < mainMenuButtons.length; i++) {
  mainMenuButtons[i].addEventListener("click", function (e) {
    // Check button current state.
    let isOpen = this.getAttribute("aria-expanded") === "true";
    menuMainlistMain[0].classList.add("menu-main__list--main-open");

    // Get level.
    let buttonLevel = this.getAttribute("data-level");
    if (buttonLevel === "0") {
      // Close all submenus.
      closeSubmenus();
    }
    if (buttonLevel === "2") {
      // Get all level 2 menu buttons.
      let levelTwoBtns = document.querySelectorAll(`[data-level="2"]`);

      // Set expanded false and remove active class for all level 2 menu buttons.
      Array.from(levelTwoBtns).forEach((el) => {
        el.setAttribute("aria-expanded", "false");
        el.classList.remove("menu-main__link--active");
      });

      // Get all level 3 submenus.
      let levelThreeMenus = document.querySelectorAll(`[data-menu-level="3"]`);

      // Close all level 3 submenus.
      Array.from(levelThreeMenus).forEach((el) => {
        el.classList.remove("menu-main__sub-list--open");
      });
    }

    let subMenu = this.nextElementSibling;
    if (isOpen) {
      // Close submenu
      subMenu.classList.remove("menu-main__sub-list--open");
      this.setAttribute("aria-expanded", "false");
      this.classList.remove("menu-main__link--active");

      // Show mobile left menu when submenus close.
      leftMenuMobileContainer.classList.remove(
        "menu-container__left-menu--hidden"
      );
    } else {
      // Open submenu.
      subMenu.classList.add("menu-main__sub-list--open");
      this.setAttribute("aria-expanded", "true");
      this.classList.add("menu-main__link--active");

      // Hide mobile left menu when submenus open.
      leftMenuMobileContainer.classList.add(
        "menu-container__left-menu--hidden"
      );

      featured.classList.add("menu-container__featured--hidden");

      Array.from(tilesMenuFeatured).forEach((el) => {
        el.classList.add("tile--menu-hidden");
      });

      if (this.closest(".menu-main__sub-list--open")) {
        this.closest(".menu-main__sub-list--open").classList.add(
          "menu-main__sub-list--hidden"
        );
      }

      // Move focus to back button on mobile devices.
      if (window.innerWidth < 992) {
        this.style.visibility = "hidden";
        // Hide all siblings.
        Array.from(
          document.getElementsByClassName(
            "menu-main__link menu-main__link--level-" + buttonLevel
          )
        ).forEach((el) => {
          el.style.visibility = "hidden";
        });

        if (buttonLevel === "2") {
          Array.from(
            document.getElementsByClassName("menu-main__link--level-1")
          ).forEach((el) => {
            el.style.visibility = "hidden";
          });
          Array.from(
            document.getElementsByClassName("back-menu__btn--level-1")
          ).forEach((el) => {
            el.style.visibility = "hidden";
          });
        }

        // Move focus to back button on mobile devices.
        if (
          this.nextElementSibling.firstElementChild.firstElementChild.classList.contains(
            "back-menu-burger__btn"
          )
        ) {
          this.nextElementSibling.firstElementChild.firstElementChild.focus();
        }
      }
      modalAccessibility("#header");
    }
  });
}

/* Function that handles all operations when main menu container close. */
function closeMainMenu() {
  mainMenuContainer.classList.remove("menu-container--open");
  mainMenuToggle.setAttribute("aria-expanded", "false");
  mainMenuToggle.classList.remove("menu-toggle--open");
  leftMenuMobileContainer.classList.remove("menu-container__left-menu--hidden");
  menuMainlistMain[0].classList.remove("menu-main__list--main-open");
  // Show other header menu (left/right).
  Array.from(headerMenus).forEach((el) => {
    el.classList.remove("header__menu--hidden");
  });

  // Set featured to shown.
  featured.classList.remove("menu-container__featured--hidden");

  // Let page to scroll.
  document.body.classList.remove("body-freeze");

  // Remove header gradient class (used on mobile menu).
  header.classList.remove("header--aqua-gradient");

  // Remove class that hides search form toggle on mobile.
  searchFormTrigger.classList.remove("search-toggle--mobile-hidden");
}

function closeSubmenus() {
  // Close all main menu submenus.
  Array.from(mainSubmenus).forEach((el) => {
    el.classList.remove("menu-main__sub-list--open");
    el.classList.remove("menu-main__sub-list--hidden");
  });

  // Set expanded false for all main menu buttons.
  Array.from(mainMenuButtons).forEach((el) => {
    el.setAttribute("aria-expanded", "false");
    el.classList.remove("menu-main__link--active");
    el.style.visibility = "visible";
  });

  // Remove hidden visibility from links.
  Array.from(
    document.getElementsByClassName("menu-main__link menu-main__link--level-0")
  ).forEach((el) => {
    el.style.visibility = "visible";
  });
  Array.from(
    document.getElementsByClassName("menu-main__link menu-main__link--level-0")
  ).forEach((el) => {
    el.style.visibility = "visible";
  });

  // Show mobile left menu when submenus close.
  leftMenuMobileContainer.classList.remove("menu-container__left-menu--hidden");

  // Set featured to shown.
  featured.classList.remove("menu-container__featured--hidden");
  Array.from(tilesMenuFeatured).forEach((el) => {
    el.classList.remove("tile--menu-hidden");
  });

  // Remove hidden visibility from links.
  Array.from(
    document.getElementsByClassName("menu-main__link menu-main__link--level-0")
  ).forEach((el) => {
    el.style.removeProperty("visibility");
  });
}

for (let i = 0; i < backMenuBtnBurger.length; i++) {
  backMenuBtnBurger[i].addEventListener("click", function (e) {
    closeSubmenus();
  });
}
for (let i = 0; i < backMenuBtnBurgerTwo.length; i++) {
  backMenuBtnBurgerTwo[i].addEventListener("click", function (e) {
    // Get all level 3 submenus.
    let levelThreeMenus = document.querySelectorAll(`[data-menu-level="3"]`);

    // Close all level 3 submenus.
    Array.from(levelThreeMenus).forEach((el) => {
      el.classList.remove("menu-main__sub-list--open");
    });

    this.closest(".menu-main__sub-list--open").classList.remove(
      "menu-main__sub-list--hidden"
    );
    Array.from(mainMenuButtons).forEach((el) => {
      el.setAttribute("aria-expanded", "false");
    });

    Array.from(
      document.getElementsByClassName("menu-main__link--level-2")
    ).forEach((el) => {
      el.style.visibility = "visible";
    });
    Array.from(
      document.getElementsByClassName("menu-main__link--level-1")
    ).forEach((el) => {
      el.style.visibility = "visible";
    });
    Array.from(
      document.getElementsByClassName("back-menu__btn--level-1")
    ).forEach((el) => {
      el.style.visibility = "visible";
    });
  });
}
